// extracted by mini-css-extract-plugin
export default {"exlyBodyContainer":"BodyWrapper_exlyBodyContainer__QDIOP","exlyBranding":"BodyWrapper_exlyBranding__ocH5R"};